<template>
  <div>
    <div class="d-flex align-center">
      <h2>施設設定</h2>
      <v-spacer />
    </div>

    <!-- Vuetify 3では indeterminate の指定方法はそのまま -->
    <v-progress-linear v-if="isLoading" indeterminate color="primary" />

    <!-- v-simple-table は v-table に変更 -->
    <v-table class="mt-4">
      <thead>
        <tr>
          <th class="text-left">施設名</th>
          <th class="text-left">住所</th>
          <th class="text-left">電話番号</th>
          <th class="text-left">施設メールアドレス</th>
          <th class="text-left"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in nurseries" :key="item.nurseryId">
          <td>{{ item.nurseryName }}</td>
          <td>{{ `${item.prefecture ?? ""}${item.address ?? ""}${item.building ?? ""}` }}</td>
          <td>{{ item.phoneNumber }}</td>
          <td>{{ item.representativeEmail }}</td>
          <td>
            <!-- small は size="small" に変更。outlined は variant="outlined" に変更 -->
            <v-btn 
              :to="`/school/${item.nurseryId}`" 
              color="primary" 
              variant="outlined" 
              size="small"
            >
              編集
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script lang="ts">
import LocalDataService from "@/service/LocalDataService";
import { nurseryModule } from "@/store/dataModule/nurseryModule";
import { OperationNurseryResponse } from "chaild-api/lib";
import { defineComponent } from "vue";

export default defineComponent({
  async mounted() {
    await this.listNurseries();
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    nurseries: function (): OperationNurseryResponse[] {
      return nurseryModule.nurseries;
    },
  },

  methods: {
    async listNurseries() {
      this.isLoading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId) {
        await nurseryModule.listNurseries({
          companyId: companyId,
        });
      }
      this.isLoading = false;
    },
    create() {
      this.$router.push({ name: "SchoolDetailSetting" });
    },
  },
});
</script>
